module.exports = __webpack_public_path__ + "img/FileModule.de304947.png";